/**
 * Adds a classes to the body based on page type/pathname
 * so that the correct styles can be applied.
 * Skilljar provides limited classing based on page type
 */
 export default function identifyPage() {
    let body = document.body;
    let currentPath = window.location.pathname;

    if (currentPath === '/') {
        body.id = 'cuu-home-page';
        body.classList.add('home-page');
        return;
    }

    if (currentPath === '/calendar') {
        body.id = 'cuu-calendar-page';
        body.classList.add('calendar-page');
        return;
    }

    let [, identifier, ...paths] = currentPath.split('/');

    if (identifier === 'page') {
        body.classList.add('search-filter-page', ...paths);
        return;
    }

    if (identifier === 'path') {
        body.classList.add('learning-path-page', ...paths);
        return;
    }

    if (identifier === 'plan') {
        body.classList.add('plans-page', ...paths);
        return;
    }

    if (identifier === 'accounts' && paths[0] === 'profile') {
        body.id = 'cuu-profile-page';
        body.classList.add('account-page', 'profile-page');
        return;
    }
}
